/** Default alert when fixed mode has no selection or file missing */
export const DEFAULT_RINGTONE_URL = '/notifikasi/notifikasi.mp3';

export const FIXED_SOUNDS_DIR = '/notifikasi/sounds';
export const RANDOM_RINGTONE_DIR = '/notifikasi/random-ringtone';

export const RANDOM_RINGTONES = [
  '02 Yamete Kudasai.mp3',
  'Ano Ne Ano Ne.mp3',
  'Ayaya Ayaya.mp3',
  'Baka no oniichan.mp3',
  'Baka! - Mary Saotome.mp3',
  'Bang loli 1.mp3',
  'Bang loli 2.mp3',
  'Boi.mp3',
  'Cacang.mp3',
  'Cute Text.mp3',
  'Darling.mp3',
  'Deja Vu.mp3',
  'Donk.mp3',
  'Fall.mp3',
  'Ganbare Ganbare.mp3',
  'Gojo Satoru - Boroboro da ne.. .mp3',
  'Hai kore.mp3',
  'Hai onii chan message.mp3',
  'Hair Twitch.mp3',
  'Harukana Receive Bamboo Bits.mp3',
  'Hey hey hey.mp3',
  'Hitomi Kuroishi Sanctuary.mp3',
  'Iyah Yamete!!!.mp3',
  'Japanese drum.mp3',
  'Japanese tone.mp3',
  'Killua Zoldyck - Baka.mp3',
  'Konichiwa....mp3',
  'Message Onegai Shimas 2.mp3',
  'Message Onegai Shimas.mp3',
  'Message yo senpai.mp3',
  'Moshi Moshi.mp3',
  'Nani nani.mp3',
  'Nezuko-chan.mp3',
  'Nico Nico Nii.mp3',
  'Nyaa Nya Nya Nya.mp3',
  'Nyanpasu.mp3',
  'Onii chan message otodoke.mp3',
  'Onii chan.mp3',
  'Orange OST.mp3',
  'Pika Pi Pikachu.mp3',
  'Pikachu.mp3',
  'Puni puniiiii.mp3',
  'Shine.mp3',
  'Toing.mp3',
  'Tuturu.mp3',
  'Uwu anime girl.mp3',
  'Wow.mp3',
  'Yowai Mo (Female version).mp3',
  'Yowai Mo (Original).mp3',
  'gamers break.mp3',
  'kawaii mail.mp3',
  'kawaii sms.mp3',
  'watashi ga hentai.mp3',
];

export function getRingtoneMode() {
  return localStorage.getItem('pingpulse_ringtone_mode') || 'fixed';
}

export function getSelectedRingtone() {
  return localStorage.getItem('pingpulse_selected_ringtone') || '';
}

/** Build public URL for a ringtone file (mode picks folder). */
export function buildRingtoneUrl(ringtone, mode = 'random') {
  if (!ringtone) {
    return DEFAULT_RINGTONE_URL;
  }
  const base = mode === 'fixed' ? FIXED_SOUNDS_DIR : RANDOM_RINGTONE_DIR;
  return `${base}/${encodeURIComponent(ringtone)}`;
}

/**
 * Resolve which audio file to play from user settings.
 * - fixed: default notifikasi.mp3, or sounds/{selected} if set
 * - random: random-ringtone/{selected} or random from collection
 */
export function resolveRingtoneUrl(options = {}) {
  const mode = options.mode ?? getRingtoneMode();
  const selected = options.selected ?? getSelectedRingtone();

  if (mode === 'fixed') {
    // Fixed mode: default file, or an explicit pick under sounds/ (not random-ringtone/)
    if (selected) {
      return buildRingtoneUrl(selected, 'fixed');
    }
    return DEFAULT_RINGTONE_URL;
  }

  if (selected) {
    return buildRingtoneUrl(selected, 'random');
  }

  if (RANDOM_RINGTONES.length > 0) {
    const idx = Math.floor(Math.random() * RANDOM_RINGTONES.length);
    return buildRingtoneUrl(RANDOM_RINGTONES[idx], 'random');
  }

  return DEFAULT_RINGTONE_URL;
}

export function volumeForSeverity(severity) {
  if (severity === 'CRITICAL') return 0.8;
  if (severity === 'HIGH') return 0.6;
  return 0.4;
}

/**
 * Play URL; on failure try default notifikasi.mp3.
 * @returns {Promise<boolean>}
 */
export function playAlertAudio(url, volume = 0.6) {
  const tryPlay = (src) => new Promise((resolve) => {
    const audio = new Audio(src);
    audio.volume = volume;
    const fail = () => resolve(false);
    audio.addEventListener('error', fail, { once: true });
    audio.play().then(() => resolve(true)).catch(fail);
  });

  return tryPlay(url).then((ok) => {
    if (ok || url === DEFAULT_RINGTONE_URL) {
      return ok;
    }
    return tryPlay(DEFAULT_RINGTONE_URL);
  });
}
